import { createContext, useContext, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { DICT } from "./dict";
import { api } from "../lib/api";

export const LANGS = ["en", "it"];
export const LangContext = createContext("en");

export const useSiteTexts = () => useQuery({
  queryKey: ["site-texts"],
  queryFn: async () => {
    try { const { data } = await api.get("/site-texts"); return data && typeof data === "object" ? data : {}; }
    catch { return {}; }
  },
  staleTime: 60000,
});

export const getPath = (obj, path) => path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);

const setPath = (obj, parts, val) => {
  if (obj == null || typeof obj !== "object") return obj;
  const copy = Array.isArray(obj) ? [...obj] : { ...obj };
  copy[parts[0]] = parts.length === 1 ? val : setPath(obj[parts[0]], parts.slice(1), val);
  return copy;
};

const applyOverrides = (base, ov) => {
  if (!ov) return base;
  return Object.entries(ov).reduce((acc, [path, val]) => (typeof getPath(base, path) === "string" ? setPath(acc, path.split("."), val) : acc), base);
};

export const useLang = () => {
  const lang = useContext(LangContext);
  const { data } = useSiteTexts();
  const t = useMemo(() => applyOverrides(DICT[lang] || DICT.en, data?.[lang]), [lang, data]);
  const to = (p = "") => `/${lang}${p}`;
  return { lang, t, to };
};

export const stoneName = (s, lang) => (lang === "it" && s?.name_it ? s.name_it : s?.name_en || "");
export const stoneText = (s, key, lang) => (lang === "it" && s?.[`${key}_it`] ? s[`${key}_it`] : s?.[`${key}_en`] || "");

export const fmt = (n) => (n === null || n === undefined || n === "" ? null : Number(n).toLocaleString("en", { maximumFractionDigits: 1 }));

export const stoneDims = (s) => {
  const l = fmt(s?.length_cm), h = fmt(s?.height_cm), t = fmt(s?.thickness_cm);
  if (!l || !h) return null;
  return s.form === "block" && t ? `${l} × ${h} × ${t} cm` : `${l} × ${h} cm`;
};
